import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { initializeFileTypeIcons } from '@uifabric/file-type-icons';

import { Agora } from './app/Agora';
import store, { history } from './app/store';
import './app/i18n';

initializeFileTypeIcons();

// The following base url has been changed due to a bug seemingly related to the uifrabric cdn:
// Link to GitHub issue: https://github.com/microsoft/fluentui/issues/33596
initializeIcons(
  'https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/',
);

export default function App() {
  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.documentElement.lang = i18n.language;
  };
  changeLanguage('da'); // Keeps language set to Danish regardless of browser preferred languages settings, if you want to make it automatic just remove this line.

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Agora />
      </ConnectedRouter>
    </Provider>
  );
}
